<template>
	<div id="leadsDiv" style="background: #f5f5f5; height: 100%; box-sizing: border-box; padding-top: 46px; overflow-y: auto">
		<NavBar fixed title="供求大厅" @click-right="onClickRight">
			<template #right>
<!--		    <Icon name="photograph" size="22" color="#666"/>--><Icon @click="toUrl()" name="plus" size="22" color="#666"/></template>
		</NavBar>

    <Search v-model="keyWord" @search="handleSearch" use-action-slot show-action placeholder="请输入关键词">
      <div slot="action" @click="handleSearch" style="width: 48px; text-align: center; color: #576b95;">搜索</div>
    </Search>

    <NoticeBar
      v-show="!!notice"
      :text="notice"
      left-icon="fire-o"
      scrollable
      style="margin-top: 2px;"
    />
    
		<div id="unreadMes" class="flex-box">
			<div style="margin: 14px" v-if="unReadNum !== 0" @click.stop="toUnReadUrl()" class="message-notice">
				<VanImage
					round
					width="2rem"
					height="2rem"
					:src="userInfo.headimgurl" style="border-radius: 5px"/>
				<span>{{unReadNum}}条新信息</span>
				<Icon
					name="arrow"
					color="#666"
					size="18"/>
			</div>
		</div>
    <allScorllPlace ref="scorll" :style="{'bottom': bottomHeight + 'px', 'top': scrollTopHeight + 'px'}"  @needReflash="onLoad({}, true)" @getNextPage="onLoad({})" class="allScorllPlace">
      <div class="row" :key="index" v-for="(item, index) in list">
        <div class="message-card" @click="showLoad = false">
          <div class="message-card__avatar" style="top: 0">
            <!--							<VanImage-->
            <!--								width="2rem"-->
            <!--								height="2rem"-->
            <!--								src="https://img.yzcdn.cn/vant/cat.jpeg"/>-->
            <VanImage
                width="2rem"
                height="2rem"
                :src="item.userModel.headBigImage"/>
          </div>
          <div class="message-card__content">
            <div class="d_f_lr" style="padding: 0 10px 5px 0">
              <span class="message-card__content-name">{{item.userModel.nickName}}</span>
              <span v-if="parseInt($store.state.userFromJava.id) === parseInt(item.userId)" @click.stop="allDelt(item, index)" style="color: red">删除</span>
            </div>
            <div @click.stop="toNewUrl('tradeLeadDetail', item)" class="message-card__content-text" style="padding-right: 10px;white-space: pre-wrap" v-html="item.content"></div>
            <div class="ExploreDiv" v-if="item.exploreMsgImage.length > 0">
              <ul v-if="item.messagetype === 'image'">
                <li :key="imgIndex" v-for="(imgItem, imgIndex) in item.exploreMsgImage" :style="item.exploreMsgImage.length === 1 ? 'width: 180px;height:auto' : 'width: 25vw;height:25vw'">
                  <div v-if="item.exploreMsgImage.length > 1">
                    <img :class="imgItem.isMaxWidth ? 'maxHeight' : 'maxWidth'" :preview="'1'" :src="imgItem.imageUrl">
                  </div>
                  <img v-if="item.exploreMsgImage.length === 1" :preview="'1'" :src="imgItem.imageUrl" style="width: 100%">
                </li>
              </ul>
            </div>
            <div v-if="item.messagetype === 'video'" style="width: 40%">
              <video :poster="item.videoThumbUrl || ''" width="100%" controls>
                <source :src="item.videoUrl" type="video/mp4">
                <!--                    <source src="../assets/1.mp4" type="video/mp4">-->
              </video>
            </div>
            <div class="d_f_lr" style="padding: 10px 10px 0 0">
              <span style="color: #737373">{{$commonJs.returnTimeago(item.createTime)}}</span>
              <div class="d_f_lr" style="width: 50%;justify-content: flex-end">
                <div style="width: 79px" class="NoWrap">
                  <Icon @click.stop="allLike(item)" :name="parseInt(item.isUp) === 1 ? 'good-job' : 'good-job-o'" color="#576b95" size="22" style="vertical-align: middle;"></Icon>
                  <span style="vertical-align: middle;">{{item.upNum}}</span>
                </div>
                <Icon @click.stop="seltload(item, 1, index)" name="chat" size="22" color="#576b95" style="margin-left: 10px;"></Icon>
                <Icon v-if="false" @click.stop="handleForward(item, index)" name="share" size="22" color="#576b95" style="margin-left: 24px;"></Icon>
              </div>
            </div>
            <div class="message-card__content-replay p_r" v-if="item.upUserInfos.length > 0 || item.reverts.length > 0">
              <section class="ArrowDiv"></section>
              <div class="PrincetonDiv">
                <ul v-if="item.upUserInfos.length > 0" :style="item.reverts.length > 0 ? 'border-bottom: 1px solid #e1e1df;' : ''">
                  <li :key="upUserIndex" v-for="(upUserItem, upUserIndex) in item.upUserInfos.slice(0,5)"><img :src="upUserItem.headBigImage"/></li>
                  <li v-if="item.upUserInfos.length > 6" @click="toNewUrl('tradeLeadLike', item)"><Icon name="ellipsis" color="#fff" size="22"/></li>
                </ul>
                <div v-if="item.reverts.length > 0">
                  <ul>
                    <li :key="reventIndex" v-for="(reventItem, reventIndex) in item.reverts">
                      <div :style="reventItem.revertDetails && reventItem.revertDetails.length > 0 ? 'margin-bottom: 10px' : ''" @click.stop="seltload(reventItem, 2, index, reventIndex)">
                        <span style="color: #576b95">{{reventItem.replyNickName}}：</span> <span>{{reventItem.content}}</span>
                      </div>
                      <div :key="reventChildIndex" v-for="(reventChildItem, reventChildIndex) in reventItem.revertDetails">
                        <span style="color: #576b95">{{reventChildItem.nikeName}} </span><span>回复</span><span style="color: #576b95"> {{reventChildItem.beReturnedNickName}}： </span><span>{{reventChildItem.content}}</span>
                      </div>
                    </li>
                    <li @click.stop="toNewUrl('tradeLeadDetail', item)" v-if="item.reverts.length > 4">
                      <span style="color: #999999">全部{{item.revertNum}}条回复</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </allScorllPlace>

<!--		<PullRefresh v-model="refreshing" @refresh="onRefresh">-->
<!--			<List v-model="loading" :finished="finished" finished-text="我是有底线的哦" @load="onLoad" sticky>-->
<!--				<div class="row" :key="index" v-for="(item, index) in list">-->
<!--					<div class="message-card" @click="showLoad = false">-->
<!--						<div class="message-card__avatar" style="top: 0">-->
<!--&lt;!&ndash;							<VanImage&ndash;&gt;-->
<!--&lt;!&ndash;								width="2rem"&ndash;&gt;-->
<!--&lt;!&ndash;								height="2rem"&ndash;&gt;-->
<!--&lt;!&ndash;								src="https://img.yzcdn.cn/vant/cat.jpeg"/>&ndash;&gt;-->
<!--              <VanImage-->
<!--                  width="2rem"-->
<!--                  height="2rem"-->
<!--                  :src="item.userModel.headBigImage"/>-->
<!--						</div>-->
<!--						<div class="message-card__content">-->
<!--              <div class="d_f_lr" style="padding: 0 10px 5px 0">-->
<!--                <span class="message-card__content-name">{{item.userModel.nickName}}</span>-->
<!--                <span v-if="parseInt($store.state.userFromJava.id) === parseInt(item.userId)" @click.stop="allDelt(item, index)" style="color: red">删除</span>-->
<!--              </div>-->
<!--							<div class="message-card__content-text" style="padding-right: 10px">{{item.content}}</div>-->
<!--              <div class="ExploreDiv" v-if="item.exploreMsgImage.length > 0">-->
<!--                <ul v-if="item.messagetype === 'image'">-->
<!--                  <li :key="imgIndex" v-for="(imgItem, imgIndex) in item.exploreMsgImage" :style="item.exploreMsgImage.length === 1 ? 'width: 180px;height:auto' : 'width: 25vw;height:25vw'">-->
<!--                    <div v-if="item.exploreMsgImage.length > 1">-->
<!--                      <img :class="imgItem.isMaxWidth ? 'maxHeight' : 'maxWidth'" :preview="'1'" :src="imgItem.imageUrl">-->
<!--                    </div>-->
<!--                    <img v-if="item.exploreMsgImage.length === 1" :preview="'1'" :src="imgItem.imageUrl" style="width: 100%">-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <div v-if="item.messagetype === 'video'" style="width: 40%">-->
<!--                <video :poster="item.videoThumbUrl || ''" width="100%" controls>-->
<!--                  <source :src="item.videoUrl" type="video/mp4">-->
<!--                  &lt;!&ndash;                    <source src="../assets/1.mp4" type="video/mp4">&ndash;&gt;-->
<!--                </video>-->
<!--              </div>-->
<!--              <div class="d_f_lr" style="padding: 10px 10px 0 0">-->
<!--                <span style="color: #737373">{{$commonJs.returnTimeago(item.createTime)}}</span>-->
<!--                <div class="d_f_lr" style="width: 50%;justify-content: flex-end">-->
<!--                  <div style="width: 79px" class="NoWrap">-->
<!--                    <Icon @click.stop="allLike(item)" :name="parseInt(item.isUp) === 1 ? 'good-job' : 'good-job-o'" color="#576b95" size="22" style="vertical-align: middle;"></Icon>-->
<!--                    <span style="vertical-align: middle;">{{item.upNum}}</span>-->
<!--                  </div>-->
<!--                  <Icon @click.stop="seltload(item, 1, index)" name="chat" size="22" color="#576b95" style="margin-left: 10px;"></Icon>-->
<!--                </div>-->
<!--              </div>-->
<!--							<div class="message-card__content-replay p_r" v-if="item.upUserInfos.length > 0 || item.reverts.length > 0">-->
<!--                <section class="ArrowDiv"></section>-->
<!--								<div class="PrincetonDiv">-->
<!--                  <ul v-if="item.upUserInfos.length > 0" :style="item.reverts.length > 0 ? 'border-bottom: 1px solid #e1e1df;' : ''">-->
<!--                    <li :key="upUserIndex" v-for="(upUserItem, upUserIndex) in item.upUserInfos.slice(0,5)"><img :src="upUserItem.headBigImage"/></li>-->
<!--                    <li v-if="item.upUserInfos.length > 6" @click="toNewUrl('tradeLeadLike', item)"><Icon name="ellipsis" color="#fff" size="22"/></li>-->
<!--                  </ul>-->
<!--                  <div v-if="item.reverts.length > 0">-->
<!--                    <ul>-->
<!--                      <li :key="reventIndex" v-for="(reventItem, reventIndex) in item.reverts">-->
<!--                        <div :style="reventItem.revertDetails && reventItem.revertDetails.length > 0 ? 'margin-bottom: 10px' : ''" @click.stop="seltload(reventItem, 2, index, reventIndex)">-->
<!--                          <span style="color: #576b95">{{reventItem.replyNickName}}</span>： {{reventItem.content}}-->
<!--                        </div>-->
<!--                        <div :key="reventChildIndex" v-for="(reventChildItem, reventChildIndex) in reventItem.revertDetails">-->
<!--                          <span style="color: #576b95">{{reventChildItem.nikeName}} </span><span>回复</span><span style="color: #576b95"> {{reventChildItem.beReturnedNickName}}</span>： {{reventChildItem.content}}-->
<!--                        </div>-->
<!--                      </li>-->
<!--                      <li @click.stop="toNewUrl('tradeLeadDetail', item)" v-if="item.reverts.length > 4">-->
<!--                        <span style="color: #999999">全部{{item.revertNum}}条回复</span>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</List>-->
<!--		</PullRefresh>-->
    <div class="loadDiv" v-if="showLoad">
      <input v-model="repContent" type="text" @blur="blurInput" class="allInput" id="loadInput" :placeholder="newPlaceholder">
      <div @click.stop="allSend()">发送</div>
    </div>
    <div class="scIDv" v-if="showNew">
      <div class="cover" @click="showNew = false"></div>
      <div>
        <p @click="toNewInfo('image')">图片消息</p>
        <p @click="toNewInfo('video')">视频消息</p>
      </div>
    </div>
	</div>
</template>

<script>
import { Search, NavBar, NoticeBar, Icon, Image as VanImage, PullRefresh, List, Toast } from 'vant'

export default {
  components: {
    Search,
    NoticeBar,
    NavBar,
    Icon,
    VanImage,
    PullRefresh,
    List
  },
  data () {
    return {
      // notice: null,
      keyWord: '',
      showNew:false,
      formUserId: parseInt(this.$route.query.formUserId),
      list: [],
      page: 1,
      size: 20,
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      newPlaceholder: '',
      showLoad: false,
      userInfo: JSON.parse(localStorage.huozhewang_userInfo),
      userFromJava: this.$store.state.userFromJava,
      repType: 1,
      repContent: '',
      repData: {},
      fatherRevenIndex: '',
      childRevenIndex: '',
      unReadNum: 0,
      topHeight: 47,
      bottomHeight: 0
    }
  },
  created() {
    this.getUnreadMessageNum()
    this.onLoad({})
  },
  computed: {
    isFreezenUser() {
      const isFreezen = this.$store.state.userFromJava.freeze;
      if (isFreezen) {
        Toast('当前账号无法继续操作');
      }
      return isFreezen;
    },
    scrollTopHeight() {
      return this.topHeight + 54 + (this.notice ? 44 : 0);
    },
    notice() {
      return `供求今日浏览量 ${this.$store.state.analysis.exploreViewCount} 次.`;
    }
  },
  mounted() {
    let mainMenu = document.querySelectorAll('.mainMenu')[0]
    let unreadMes = document.querySelector('#unreadMes')
    if (mainMenu) {
      this.bottomHeight = mainMenu.clientHeight
    }
    if (unreadMes) {
      this.topHeight = unreadMes.clientHeight + 47
    }
    // let dom = document.getElementById('leadsDiv')
    // if (dom) {
    //   dom.onscroll = p => {
    //     console.log(p)
    //   }
    // }
  },
  methods: {
    handleSearch() {
      this.list = []
      this.onLoad({});
    },
    blurInput () {
      setTimeout(p => {
        this.showLoad = false
      }, 100)
    },
    toNewUrl (url, item) {
      this.$router.push({
        name: url,
        query: {
          formId: item.id
        }
      })
    },
    // 获取未读消息
    getUnreadMessageNum () {
      this.$axiox.post('/explore/unreadMessageNum').then(msg => {
        this.unReadNum = msg.data.unReadNum || 0
        this.$nextTick(p => {
          let unreadMes = document.querySelector('#unreadMes')
          if (unreadMes) {
            this.topHeight = unreadMes.clientHeight + 47
          }
        })
      })
    },
    toUnReadUrl () {
      this.$router.push({
        name: 'tradeLeadMessageList'
      })
    },
    toUrl () {
      this.showNew = true
    },
    toNewInfo (type) {
      this.$router.push({
        name: 'tradeLeadNew',
        query: {
          formType: type
        }
      })
      // setTimeout(p => {
      //   window.location.reload()
      // }, 100)
    },
    onClickRight () {},
    onRefresh(param) {
      this.finished = false;
      this.loading = true;
      this.onLoad(param);
    },
    onLoad(condition, refreshing) {
      if (refreshing) {
        this.page = 1;
        this.list = [];
        // this.refreshing = false;
      }
      const targetParam = {
        page: this.page++,
        size: this.size
      };
      if (this.keyWord) {
        targetParam.keyWord = this.keyWord
      }
      let newUserId = {
        publishedId: this.formUserId || 0
      }
      this.$store.dispatch('getDynamicList', {...targetParam, ...condition, ...newUserId}).then(({rows, total}) => {
        this.handleImg(rows, total)
        // this.$nextTick(p => {
        //   this.$previewRefresh()
        // })
      }).catch(() => {
        this.loading = false;
        this.error = true
        this.finished = true;
      })
    },
    async handleImg (rows, total) {
      this.list = [].concat(this.list, rows)
      if (this.list.length > 0) {
        for (let i = 0; i <  this.list.length; i++) {
          this.list[i].upUserInfos =  this.list[i].upUserInfos || []
          for (let j = 0; j < this.list[i].reverts.length; j++) {
            this.list[i].reverts[j].revertDetails = this.list[i].reverts[j].revertDetails || []
          }
          for (let j = 0; j < this.list[i].exploreMsgImage.length; j++) {
            const img = new Image()
            img.src = this.list[i].exploreMsgImage[j].imageUrl
            img.onload = () => {
              this.list[i].exploreMsgImage[j].isMaxWidth = img.width > img.height
              this.$forceUpdate()
            }
            // let data = await this.getImgWidth(this.list[i].exploreMsgImage[j].imageUrl)
            // this.list[i].exploreMsgImage[j].isMaxWidth = data.width > data.height
          }
        }
      }
      this.loading = false;
      if (this.list.length >= total) {
        this.finished = true;
      }
    },
    getImgWidth (imgSrc) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = imgSrc
        img.onload = () => {
          resolve(img)
        }
      })
    },
    // getUpUserList () {
    //   let data = {
    //     page: 1,
    //     size: 9999
    //   }
    //   this.$axiox.post('/explore/upUserPage', )
    // },
    allLike (item) {
      item.isUp = parseInt(item.isUp) === 0 || item.isUp === null ? 1 : 0
      if (parseInt(item.isUp) === 1) {
        console.log('点赞')
        let data = {
          id: item.id,
          upSize: 5
        }
        this.$axiox.post('/explore/upExploreMessage', data).then(msg => {
          item.upNum = msg.data.upVoteNum
          item.upUserInfos = msg.data.upUserList
          this.$commonJs.showTips('点赞成功')
        })
      } else {
        console.log('取消')
        let data = {
          id: item.id,
          upSize: 5
        }
        this.$axiox.post('/explore/cancelUpExploreMessage', data).then(msg => {
          item.upNum = msg.data.upVoteNum
          item.upUserInfos = msg.data.upUserList || []
          this.$commonJs.showTips('取消点赞')
        })
      }
    },
    allDelt (item, index) {
      this.$commonJs.doubleComfirm({
        title: '提示',
        content: '是否确定删除',
        buttonType: '2',
        successFun: () => {
          let data = {
            id: item.id
          }
          this.$axiox.post('/explore/clearMsg', data).then(() => {
            this.$commonJs.showTips('删除成功')
            this.list.splice(index, 1)
          })
        },
        errorFun: () => {
        }
      })
    },
    async handleForward({ id }) {
      const data = { id }
      this.$axiox.post('/explore/forwardMsg', data).then(() => {
        this.$commonJs.showTips('转发成功');
      })
    },
    seltload (item, num, index, childIndex) {
      this.repType = num
      this.repData = JSON.parse(JSON.stringify(item))
      this.repContent = ''
      if (num === 1) {
        this.newPlaceholder = '请输入'
        this.showLoad = true
        this.fatherRevenIndex = index
      } else {
        this.newPlaceholder = '回复 ' + item.replyNickName
        this.showLoad = true
        this.fatherRevenIndex = index
        this.childRevenIndex = childIndex
      }
      this.$nextTick(() => {
        document.getElementById('loadInput').focus()
      })
    },
    allSend () {
      if (parseInt(this.repType) === 1) {
        let data = {
          id: this.repData.id,
          content: this.repContent
        }
        this.$axiox.post('/explore/replyExploreMessage', data).then(msg => {
          this.list[this.fatherRevenIndex].reverts.push(msg.data)
          this.repContent = ''
        })
      } else {
        let data = {
          beReturnedUserId: this.repData.replyUserId,
          content: this.repContent,
          revertId: this.repData.id
        }
        this.$axiox.post('/explore/replyExploreRevert', data).then(msg => {
          this.list[this.fatherRevenIndex].reverts[this.childRevenIndex].revertDetails.push(msg.data)
          this.repContent = ''
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scIDv {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1100;
}
.scIDv > div:last-child {
  position: absolute;
  top: 40vh;
  left: 15%;
  z-index: 1000;
  width: 70%;
  background-color: white;
  text-align: center;
  border-radius: 5px;
}
.scIDv > div:last-child p {
  padding: 10px 0;
  font-size: 14px;
}
.loadDiv {
  background-color: white;
  padding:10px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.loadDiv > input {
  width: calc(100% - 80px);
  background-color: #f5f5f5;
  margin-right: 10px;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
}
.loadDiv > input::placeholder {
  font-size: 14px;
}
.loadDiv > div {
  display: inline-block;
  vertical-align: middle;
  padding: 5px 10px;
  background-color: #ee0a24;
  border-radius: 5px;
  color: white;
  font-size: 16px;
}
.PrincetonDiv {
  background-color: #f5f5f5;
  margin-right: 10px;
}
.PrincetonDiv > ul {
  white-space: nowrap;
}
.PrincetonDiv > ul li {
  display: inline-block;
  width: calc(10vw - 3px);
  height: calc(10vw - 3px);
  vertical-align: middle;
  margin: 5px;
  border-radius: 100%;
}
.PrincetonDiv > ul li img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.PrincetonDiv > ul li:last-child {
  background-color: #97aad0;
  border-radius: 100%;
  text-align: center;
  line-height: calc(10vw - 3px);
}
.PrincetonDiv > div > ul {
  padding-top: 10px;
}
.PrincetonDiv > div > ul li {
  padding: 0 10px 10px 10px;
  white-space: normal;
}
.NoWrap{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ExploreDiv {
  width: 100%;
  padding-top: 10px;
}
.ExploreDiv ul {
  white-space: normal;
}
.ExploreDiv ul li {
  display: inline-block;
  vertical-align: middle;
  width: 25vw;
  height: 25vw;
  margin-right: 10px;
  margin-bottom: 10px;
}
.ExploreDiv ul li > div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.d_f_lr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-box {
		display: flex;
		justify-content: center;
		background-color: #fff;
	}

	.message-notice {
		width: 180px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		background-color: #383839;
		border-radius: 5px;
		padding: 5px;
		color: #fff;
		font-size: 13px;
	}

	.message-card {
		display: flex;
		align-items: flex-start;
		font-size: 15px;
		color: #000;
		padding: 15px 0px 20px 0;
		background-color: #fff;
		border-bottom: 1px solid #e1e1df;

		&__avatar {
			margin: 0px 10px;
			position: relative;
			top: 6px;
		}

		&__content {
			flex: 1;
		}

		&__content-name {
			font-size: 15px;
			color: #576b95;
		}

		&__content-photo {
			margin: 10px 0px;

			.row {
				margin-bottom: 7px;
				height: 80px;
			}

			.col {
				display: inline-block;
				margin-right: 7px;
				width: 80px;
				height: 80px;
			}

			.row.hasOne {
				height: 200px;

				.col {
					width: 200px;
					height: 200px;
				}
			}

			.photo-item {
				width: 100%;
				height: 100%;
			}

		}

		&__content-operate {
			color: #666;
			font-size: 14px;
			display: flex;
			align-items: center;

			.lover {
				margin-left: 120px;
				margin-right: 20px;
				display: flex;
				align-items: flex-end;
			}

			.replay {
				display: flex;
			}

		}

	}
</style>

